
(function(){
  "use strict";
  var $ = function(id){ return document.getElementById(id); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.solenToast = function(msg){
    var t = document.querySelector('.toast');
    if (t) t.remove();
    t = document.createElement('div');
    t.className = 'toast'; t.setAttribute('role','status'); t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function(){ if (t) t.remove(); }, 2400);
  };

  /* header search */
  var wrap = $('search'), btn = $('searchBtn'), input = $('searchInput');
  if (wrap && btn && input){
    var form = wrap.closest('form');
    function setOpen(o){
      wrap.classList.toggle('open', o);
      btn.setAttribute('aria-expanded', String(o));
      input.tabIndex = o ? 0 : -1;
      if (o) input.focus(); else input.value = '';
    }
    btn.addEventListener('click', function(e){
      if (!wrap.classList.contains('open')){ e.preventDefault(); e.stopPropagation(); setOpen(true); }
      else if (!input.value){ e.preventDefault(); e.stopPropagation(); setOpen(false); }
    });
    input.addEventListener('click', function(e){ e.stopPropagation(); });
    input.addEventListener('keydown', function(e){ if (e.key === 'Escape'){ setOpen(false); btn.focus(); } });
    document.addEventListener('click', function(){
      if (wrap.classList.contains('open') && !input.value) setOpen(false);
    });
  }

  /* scroll reveal */
  if (!reduce && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e, i){
        if (!e.isIntersecting) return;
        var el = e.target;
        setTimeout(function(){ el.classList.remove('pre'); }, i * 90);
        io.unobserve(el);
      });
    }, { rootMargin:'0px 0px -10% 0px', threshold:0.08 });
    document.querySelectorAll('[data-reveal]').forEach(function(n){
      var r = n.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.95) return;
      n.classList.add('pre'); io.observe(n);
    });
    setTimeout(function(){
      document.querySelectorAll('[data-reveal].pre').forEach(function(n){ n.classList.remove('pre'); });
    }, 6000);
  }

  /* play-once video: starts the first time it actually scrolls into view (not on page
     load), then freezes on its thumbnail image once it has played through. */
  var onceVideos = document.querySelectorAll('[data-play-once-video]');
  if (onceVideos.length){
    var startVideo = function(v){
      if (v.dataset.played === '1') return;
      v.dataset.played = '1';
      var p = v.play();
      if (p && p.catch) p.catch(function(){ /* blocked (data saver etc.) — poster stays up */ });
    };
    onceVideos.forEach(function(v){
      var poster = v.nextElementSibling && v.nextElementSibling.hasAttribute('data-play-once-poster')
        ? v.nextElementSibling : null;
      function showPoster(){
        v.style.display = 'none';
        if (poster) poster.style.display = 'block';
      }
      if (reduce){
        /* respect reduced-motion: never play, go straight to the still image */
        showPoster();
        return;
      }
      v.addEventListener('ended', showPoster);

      if (!('IntersectionObserver' in window)){ startVideo(v); return; }
      var vio = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){
            startVideo(v);
            vio.disconnect();           /* play-once: no need to keep watching */
          }
        });
      }, { threshold: 0.35 });          /* a third of the frame on screen before it starts */
      vio.observe(v);
    });
  }

  /* size guide: gender / unit pill toggles */
  var sizeControls = document.querySelector('[data-size-controls]');
  if (sizeControls){
    var genderPanels = document.querySelectorAll('[data-gender-panel]');
    sizeControls.querySelectorAll('[data-group="gender"] .pill').forEach(function(btn){
      btn.addEventListener('click', function(){
        sizeControls.querySelectorAll('[data-group="gender"] .pill').forEach(function(b){ b.classList.toggle('is-on', b === btn); });
        var val = btn.getAttribute('data-value');
        genderPanels.forEach(function(p){ p.hidden = p.getAttribute('data-gender-panel') !== val; });
      });
    });
    sizeControls.querySelectorAll('[data-group="unit"] .pill').forEach(function(btn){
      btn.addEventListener('click', function(){
        sizeControls.querySelectorAll('[data-group="unit"] .pill').forEach(function(b){ b.classList.toggle('is-on', b === btn); });
        var isCm = btn.getAttribute('data-value') === 'cm';
        document.querySelectorAll('[data-cm]').forEach(function(el){ el.hidden = !isCm; });
        document.querySelectorAll('[data-in]').forEach(function(el){ el.hidden = isCm; });
      });
    });
  }

  /* product reviews: load-more opens a modal with every review */
  var reviewsOpenBtn = document.querySelector('[data-reviews-open]');
  var reviewsModal = document.querySelector('[data-reviews-modal]');
  if (reviewsOpenBtn && reviewsModal){
    function openReviewsModal(){
      reviewsModal.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = reviewsModal.querySelector('.reviews-modal-close');
      if (closeBtn) closeBtn.focus();
    }
    function closeReviewsModal(){
      reviewsModal.hidden = true;
      document.body.style.overflow = '';
      reviewsOpenBtn.focus();
    }
    reviewsOpenBtn.addEventListener('click', openReviewsModal);
    reviewsModal.querySelectorAll('[data-reviews-close]').forEach(function(el){
      el.addEventListener('click', closeReviewsModal);
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && !reviewsModal.hidden) closeReviewsModal();
    });
  }

  /* cart: qty changes auto-submit the bag (no separate "Update bag" button) */
  var cartForm = $('cartForm');
  if (cartForm){
    var cartSubmitTimer = null;
    function submitCartForm(){
      clearTimeout(cartSubmitTimer);
      cartForm.submit();
    }
    cartForm.querySelectorAll('[data-cart-qty]').forEach(function(input){
      /* fires immediately for the native stepper arrows and on blur after typing */
      input.addEventListener('change', submitCartForm);
      /* also fires while typing (or holding the stepper), in case the field never blurs */
      input.addEventListener('input', function(){
        clearTimeout(cartSubmitTimer);
        cartSubmitTimer = setTimeout(submitCartForm, 700);
      });
      input.addEventListener('keydown', function(e){
        if (e.key === 'Enter'){ e.preventDefault(); submitCartForm(); }
      });
    });
  }

  /* collection: sort + facets drive navigation (moved off inline handlers) */
  var sortSel = $('sortSelect');
  if (sortSel){
    sortSel.addEventListener('change', function(){
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sortSel.value);
      u.searchParams.delete('page');       /* a new sort starts again at page 1 */
      window.location = u.toString();
    });
  }
  var facetPanel = document.querySelector('.facets');
  if (facetPanel){
    facetPanel.addEventListener('change', function(e){
      var box = e.target.closest('input[data-facet-url]');
      if (box) window.location = box.getAttribute('data-facet-url');
    });
  }

  /* newsletter: let Shopify handle the post, just validate */
  var nf = document.querySelector('.news form');
  if (nf){
    nf.addEventListener('submit', function(e){
      var f = nf.querySelector('input[type=email]');
      if (!f) return;
      var v = f.value.trim();
      if (!v || v.indexOf('@') < 1 || v.indexOf('.') < 0){
        e.preventDefault(); window.solenToast('ENTER A VALID EMAIL'); f.focus();
      }
    });
  }
})();
